"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMenuConfig = void 0;
const getMnemonicConfig_1 = require("./getMnemonicConfig");
const getNFCertConfig_1 = require("./getNFCertConfig");
const getMenuConfig = (domain, user, locale, logger) => {
    switch (domain) {
        case "MNEMONIC":
            return (0, getMnemonicConfig_1.getMneConfig)(user, locale);
        case "NFCERT":
            return (0, getNFCertConfig_1.getNFCertConfig)(user, locale);
        default:
            logger.logError(`Unknown domain: ${domain}`);
            return (0, getMnemonicConfig_1.getMneConfig)(user, locale);
    }
};
exports.getMenuConfig = getMenuConfig;
